<template>
  <div class="grid-x grid-margin-x justify-between gap-y-4">
    <div class="cell small-auto large-shrink">
      <dl class="description-list inline-grid gap-x-16 text-base">
        <dt qaid="warranty-details-packing-slip-number" v-html="bp('packingSlipNumber')" />
        <dd v-if="consignment.packingSlipAvailable">
          <template>
            <pdl-link
              standalone
              content="consignment.packingSlip"
              qaid="warranty-details-packing-slip-download"
              @click="downloadPackingSlip"
            >
              {{ consignment.packingSlip }}
            </pdl-link>
          </template>
        </dd>
        <dd v-else v-html="consignment.packingSlip" />

        <dt qaid="warranty-details-shipment-date" v-html="bp('shipDate')" />
        <dd v-html="consignment.shipDate" />

        <dt qaid="warranty-details-bill-number" v-html="bp('billTo')" />
        <dd v-html="warrantyDetails.retailerId" />

        <dt qaid="warranty-details-carrier-name" v-html="bp('shipmentCarrier')" />
        <dd v-html="consignment.tracking.shipmentCarrier" />

        <dt qaid="warranty-details-tracking-number" v-html="bp('trackingNumber')" />
        <dd>
          <template>
            <pdl-link
              standalone
              :href="`${consignment.tracking.shipmentTrackingUrl}`"
              target="_blank"
              content="consignment.tracking.shipmentTrackingNumber"
              qaid="warranty-details-shipment-tracking-url"
            >
              {{ consignment.tracking.shipmentTrackingNumber }}
            </pdl-link>
          </template>
        </dd>

        <dt qaid="warranty-details-customer-PO" v-html="bp('customerPO')" />
        <dd v-html="warrantyDetails.details.customerPo" />
      </dl>
    </div>

    <div class="cell small-auto large-shrink">
      <dl class="description-list inline-grid gap-x-16 text-base">
        <dt qaid="warranty-details-billing-address" v-html="bp('billToAddress')" />
        <dd>
          <p v-html="warrantyDetails.billingAddress.billTo" />
          <p v-html="warrantyDetails.billingAddress.line1" />
          <p>
            <span
              v-if="warrantyDetails.billingAddress.billToCity"
              v-html="`${warrantyDetails.billingAddress.billToCity}, `"
            />
            <span v-html="warrantyDetails.billingAddress.billToStateOrProvince" />
            <span class="ml-25" v-html="warrantyDetails.billingAddress.billToPostalCode" />
          </p>
        </dd>

        <dt qaid="warranty-details-shipping-address" v-html="bp('shipToAddress')" />
        <dd>
          <p v-html="consignment.shippingAddress.companyName" />
          <p v-html="consignment.shippingAddress.line1" />
          <p v-html="consignment.shippingAddress.line2" />
          <p>
            <span v-if="consignment.shippingAddress.town" v-html="`${consignment.shippingAddress.town}, `" />
            <span v-html="consignment.shippingAddress.region.isocodeShort" />
            <span class="ml-25" v-html="consignment.shippingAddress.postalCode" />
          </p>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import {PdlLink} from '@pedal/pdl-link';

export default {
  components: {PdlLink},
  props: {
    warrantyDetails: {
      type: Object,
      required: true,
    },
    consignment: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState('backend', ['encodedContextPath']),
  },

  methods: {
    downloadPackingSlip() {
      window.location.href = `${this.encodedContextPath}${this.consignment.packingListURL}`;
    },
  },
};
</script>

<style scoped>
.description-list {
  grid-template-columns: auto;
}

@screen md {
  .description-list {
    grid-template-columns: auto 1fr;
  }
}
</style>
